import {
  DefaultSendVerificationCodeParams,
  DefaultVerifyCodeParams,
  SendVerificationCodeResponse,
  VerifyCodeResponse,
} from 'src/features/verification/data/service/VerificationService.types';

export interface VerificationRepositoryInterface {
  sendVerificationCode(
    params: DefaultSendVerificationCodeParams
  ): Promise<SendVerificationCodeResponse>;
  verifyCode(
    params: DefaultVerifyCodeParams
  ): Promise<VerifyCodeResponse | void>;
}

export enum VerificationErrorCode {
  InvalidCode = '60022',
  CodeExpired = '60023',
  TooManyAttempts = '60051',
  CodeNotSent = '60033',
  ServiceUnavailable = '60035',
  UnknownError = 'unknown_error',
  Unauthorized = '401',
}

export const verificationErrorMessages: Record<VerificationErrorCode, string> =
  {
    [VerificationErrorCode.InvalidCode]:
      'El código de verificación es inválido.',
    [VerificationErrorCode.CodeExpired]:
      'El código de verificación ha expirado.',
    [VerificationErrorCode.TooManyAttempts]:
      'Demasiados intentos fallidos. Por favor, solicita un nuevo código.',
    [VerificationErrorCode.CodeNotSent]:
      'El código de verificación no se pudo enviar.',
    [VerificationErrorCode.ServiceUnavailable]:
      'El servicio no está disponible. Por favor, intenta más tarde.',
    [VerificationErrorCode.UnknownError]:
      'Ocurrió un error desconocido. Por favor, intenta nuevamente.',
    [VerificationErrorCode.Unauthorized]:
      'No autorizado. Por favor, inicia sesión.',
  };

export class VerificationError extends Error {
  code: VerificationErrorCode;

  constructor(code: VerificationErrorCode) {
    super(
      verificationErrorMessages[code] ||
        verificationErrorMessages[VerificationErrorCode.UnknownError]
    );
    this.name = 'VerificationError';
    this.code = code;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
